import axiosActionsFactory from '../../axiosHelpers';
import { UrlService } from '../../../../services';
import { getSelectedCompany } from '../../../selectors';

export const ACTIVATE_TELEMATIC_ACCOUNT_DEVICES = axiosActionsFactory('ACTIVATE_TELEMATIC_ACCOUNT_DEVICES');

const activateTelematicAccountDevices = (
  accountId, params, requestBody,
) => (dispatch) => dispatch({
  type: ACTIVATE_TELEMATIC_ACCOUNT_DEVICES.START,
  payload: {
    request: {
      url: UrlService.providerAccountActivateDevices(accountId),
      method: 'post',
      params,
      data: requestBody,
    },
  },
});

export const activateDevices = (accountId, deviceIds, authStateId) => (dispatch, getState) => {
  const state = getState();
  const contextCompanyId = getSelectedCompany(state);

  return dispatch(activateTelematicAccountDevices(
    accountId, { contextCompanyId }, { deviceIds, authStateId },
  ));
};
